<template>
  <div class="status-cell-renderer d-flex align-items-center gap-1 fs-14 text-uppercase">
    <GuBadge
      v-if="renderType === 'badge' && props.params.value"
      :variant="badgeTypes[props.params.value] || 'light'"
    >
      {{ props.params.value }}
    </GuBadge>

    <template v-else-if="renderType === 'dot'">
      <GuBadge
        :variant="props.params.type"
        class="me-2"
      />
      <span
        v-if="props.params.text"
        :class="`text-${props.params.type}`"
      >
        {{ props.params.text }}
      </span>
    </template>

    <template v-else-if="renderType === 'icon'">
      <i
        v-if="props.params.icon"
        :class="`bx bx-${props.params.icon} text-${props.params.type} me-2`"
      />
      <span
        v-if="props.params.text"
        :class="`text-${props.params.type}`"
      >
        {{ props.params.text }}
      </span>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { GuBadge } from '@shared/gu-components/badge'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const DEFAULT_BADGE_TYPES = {
  Active: 'info',
  Approved: 'success',
  Pending: 'primary',
  Disabled: 'light',
}

const badgeTypes = computed(() => {
  return props.params.badgeTypes || DEFAULT_BADGE_TYPES
})

const renderType = computed(() => {
  const validVersions = ['badge', 'dot', 'icon']
  return validVersions.includes(props.params.version)
    ? props.params.version
    : 'badge'
})
</script>

<style scoped>
.status-cell-renderer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>